<template>
  <div>
    <p class="title is-4 mb-2">Frame</p>
    <div class="up-input-group">
      <div>
        <up-numberinput
          v-model="drag_box.styles.width"
          size="sm"
          label="Width"
          labelIcon="mdi mdi-alpha-w-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="drag_box.styles.height"
          size="sm"
          label="Height"
          labelIcon="mdi mdi-alpha-h-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="drag_box.num_columns"
          size="sm"
          label="Number of Columns"
          labelIcon="mdi mdi-dots-horizontal"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="drag_box.num_rows"
          size="sm"
          label="Number of Rows"
          labelIcon="mdi mdi-dots-vertical"
        ></up-numberinput>
      </div>
    </div>
    <style-editor
      class="mt-5"
      title="Drop Zone"
      v-model="drag_box.hollow_styles"
      show_bg_color
      show_border_color
      show_x
      show_y
    ></style-editor>
    <style-editor
      class="mt-5"
      title="Box"
      v-model="drag_box.square_styles"
      show_width
      show_height
      show_bg_color
      show_border_color
    ></style-editor>
    <div class="column is-12 mt-6">
      <show-drag-box
        :is_drop_zone_draggable="true"
        :show_border="true"
        :drag_box="drag_box"
      ></show-drag-box>
    </div>
  </div>
</template>

<script>
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";
import ShowDragBox from "./ShowDragBox.vue";
import { defaultDragBoxValue } from "./utils";

import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
export default {
  name: "set-drag-box",
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    ShowDragBox,
    StyleEditor,
    UpNumberinput,
  },
  data() {
    return {
      drag_box: this.value ? this.value : defaultDragBoxValue(),
    };
  },
  watch: {
    drag_box: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.drag_box = new_val;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
